module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };


// WEBPACK FOOTER //
// ../node_modules/babel-runtime/core-js/object/set-prototype-of.js